import React from "react";
import Account from "../../common/account";
import { getBankerProfile, updateBankerProfile } from "../../../services/banker.service";

interface Props {
  bankerId: string;
  loggedInUserId?: string;
}

const BankerAccount: React.FC<Props> = ({ bankerId, loggedInUserId }) => {
  const title = bankerId === loggedInUserId ? "Your Profile" : "Banker Profile";
  const subtitle = bankerId === loggedInUserId ? "Keep your details up to date" : "Keep banker details up to date";

  return (
    <Account
      userId={bankerId}
      loggedInUserId={loggedInUserId}
      getProfile={getBankerProfile}
      updateProfile={updateBankerProfile}
      title={title}
      subtitle={subtitle}
      showSignature={true}
    />
  );
};

export default BankerAccount;
